(function () {

    "use strict";

    angular.module("sphforms.workflow", [
        // External
        "ui.router"
    ]);

}());